export const getAskBarBorderColor = ({
  showValidationMessage,
  showAiSdrGlow,
  isAiSdrFocused,
  theme
}) => {
  if (showValidationMessage) return theme.spotlight.color.error;
  if (!showAiSdrGlow) return theme.spotlight.color.border;
  return isAiSdrFocused ? theme.spotlight.color.orange : theme.spotlight.color.orangeMuted;
};